import {publicClientApplication} from 'src/app/constants/config/authConfig';
import {hasOneOfRoles} from 'src/app/utilities/helpers/userRole';
import {Roles} from 'src/data/enums/roles';

// A function to get the current roles dynamically
const getRoles = (): Roles[] => {
    return (publicClientApplication.getActiveAccount()?.idTokenClaims?.roles || []) as Roles[];
};

// Define your permission checks using the `getRoles` function
const isAdmin = () => hasOneOfRoles([Roles.ADMINISTRATOR], getRoles());

export const nameUpdateRoles = [
    Roles.ADMINISTRATOR,
    Roles.EVENTS_ADMINISTRATOR
];

const canUpdateEventName = () => hasOneOfRoles(nameUpdateRoles, getRoles());

export const organizerUpdateRoles = [
    Roles.ADMINISTRATOR,
    Roles.EVENTS_CONTRIBUTOR,
    Roles.EVENTS_ADMINISTRATOR
];

const canUpdateEventOrganizer = () => hasOneOfRoles(organizerUpdateRoles, getRoles());

export const seriesUpdateRoles = [
    Roles.ADMINISTRATOR,
    Roles.EVENTS_CONTRIBUTOR,
    Roles.EVENTS_ADMINISTRATOR
];

const canUpdateEventSeries = () => hasOneOfRoles(seriesUpdateRoles, getRoles());

export const eventCategoryUpdateRoles = [
    Roles.ADMINISTRATOR,
    Roles.EVENTS_CONTRIBUTOR,
    Roles.EVENTS_ADMINISTRATOR
];

const canUpdateEventCategory = () => hasOneOfRoles(eventCategoryUpdateRoles, getRoles());

export const geoBlockedCountriesUpdateRoles = [
    Roles.ADMINISTRATOR,
    Roles.EVENTS_ADMINISTRATOR
];

const canUpdateGeoBlockedCountries = () => hasOneOfRoles(geoBlockedCountriesUpdateRoles, getRoles());

export const DeleteItineraryFileRoles = [
    Roles.ADMINISTRATOR,
    Roles.TICKETS_ADMINISTRATOR,
    Roles.TICKETS_CONTRIBUTOR
];

const canDeleteItineraryFile = () => hasOneOfRoles(DeleteItineraryFileRoles, getRoles());

export const deleteTicketRoles = [
    Roles.ADMINISTRATOR,
    Roles.TICKETS_ADMINISTRATOR
];

const canDeleteTicket = () => hasOneOfRoles(deleteTicketRoles, getRoles());

export const ticketLockStatusModifyRoles = [
    Roles.ADMINISTRATOR,
    Roles.TICKETS_CONTRIBUTOR,
    Roles.TICKETS_ADMINISTRATOR
];

const canModifyTicketLockedStatus = () => hasOneOfRoles(ticketLockStatusModifyRoles, getRoles());

export const changePurchaseRoles = [
    Roles.ADMINISTRATOR,
    Roles.PURCHASES_CONTRIBUTOR,
    Roles.PURCHASES_ADMINISTRATOR
];

const canChangePurchasePrices = () => hasOneOfRoles(changePurchaseRoles, getRoles());

const canLockOrCloseEvent =
    hasOneOfRoles(
        [
            Roles.EVENTS_ADMINISTRATOR, Roles.EVENTS_CONTRIBUTOR
        ],
        getRoles()
    ) ||
    isAdmin();

export const canLockEvent = () => canLockOrCloseEvent;

export const canUnlockEvent = () =>
    hasOneOfRoles([
        Roles.EVENTS_ADMINISTRATOR, Roles.EVENTS_CONTRIBUTOR
    ], getRoles()) ||
    isAdmin();
export const canCloseEvent = () => canLockOrCloseEvent;

export default {
    canUpdateEventName,
    canUpdateEventOrganizer,
    canUpdateEventSeries,
    canModifyTicketLockedStatus,
    canChangePurchasePrices,
    canUpdateEventCategory,
    canUpdateGeoBlockedCountries,
    canDeleteItineraryFile,
    canDeleteTicket,
};

// User-facing messages: replace direct role names with generalized
export const NO_PERMISSION_UPDATE_PURCHASES = "You do not have permission to update purchases.";
